import * as React from "react";
import { IconButton, ThemeProvider, Popover } from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useRef } from "react";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/system";
import { CustomizedDialogs } from "../../component/BreakPoint/Modal";
import { getColorArrayFromBreakPoints } from "../Utils/legendCommonFunction";
import { ColorScale } from "../BreakPoint/ColorScale";
var StyledRootContainer = styled("div")(function (_a) {
    var theme = _a.theme;
    return ({
        display: "flex",
        gap: theme.spacing(2),
        height: 20,
    });
});
var StyledColorScaleContainer = styled("div")({
    display: "flex",
    marginTop: 8,
    marginLeft: -10,
    height: 27,
    width: 248,
    "&:hover": {
        backgroundColor: "#f1f1f1",
        cursor: "pointer",
    },
});
var StyledTextureContainer = styled("div")({
    height: "13px",
    width: "100px",
    marginTop: "6px",
    marginLeft: "5px",
});
var StyledEditContainer = styled("div")({
    "&:hover": {
        backgroundColor: "#f1f1f1",
    },
    height: "50%",
    width: "100%",
    cursor: "pointer",
});
var StyledCustomScales = styled("div")({
    whiteSpace: "nowrap",
    fontSize: "small",
    fontWeight: "700",
    margin: "6px 0px 0px 6px",
    cursor: "pointer",
});
export var LegendComp = function (_a) {
    var colorScaleBreakpoints = _a.colorScaleBreakpoints, editedData = _a.editedData, isModal = _a.isModal, handleModalClick = _a.handleModalClick, customScalesName = _a.customScalesName;
    var _b = React.useState(colorScaleBreakpoints), breakpointValues = _b[0], setBreakPointValues = _b[1];
    var _c = React.useState(), customizedBreakpoints = _c[0], setCustomizedBreakpoints = _c[1];
    React.useEffect(function () {
        setBreakPointValues(colorScaleBreakpoints);
    }, [colorScaleBreakpoints, colorScaleBreakpoints.length]);
    var orderedSelectedColors = React.useMemo(function () {
        return Object.values(breakpointValues.colorArray
            ? breakpointValues.colorArray
            : breakpointValues).sort(function (a, b) { return a.position - b.position; });
    }, [breakpointValues]);
    var arrayOfColors = React.useMemo(function () {
        return orderedSelectedColors.length > 0
            ? getColorArrayFromBreakPoints(orderedSelectedColors)
            : [];
    }, [orderedSelectedColors]);
    var _d = React.useState(false), popUpState = _d[0], setPopUpState = _d[1];
    var _e = React.useState(null), anchorEl = _e[0], setAnchorEl = _e[1];
    var handleClick = function (event) {
        document.removeEventListener("mousedown", handleModalClick);
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var openEditModal = React.useCallback(function (data) {
        setPopUpState(data.bubbles);
        setAnchorEl(null);
    }, []);
    var deleteLegend = function () {
        setBreakPointValues([]);
        editedData({ colorArray: colorScaleBreakpoints, customizeFlag: false });
    };
    React.useEffect(function () {
        if (isModal) {
            popUpState
                ? document.removeEventListener("mousedown", handleModalClick)
                : document.addEventListener("mousedown", handleModalClick);
        }
    }, [handleModalClick, isModal, popUpState]);
    var scaleBreakpoints = React.useCallback(function (value) {
        if (value) {
            editedData({ colorArray: value, customizeFlag: true });
            setBreakPointValues(value);
            setCustomizedBreakpoints(value);
        }
    }, [editedData]);
    var appendCustomizedBreakPoints = React.useCallback(function () {
        // if breakpoints are editted then use customizedBreakpoints
        editedData({
            colorArray: customizedBreakpoints
                ? customizedBreakpoints
                : breakpointValues,
            customizeFlag: true,
        });
    }, [breakpointValues, customizedBreakpoints, editedData]);
    var open = Boolean(anchorEl);
    var id = open ? "simple-popover" : undefined;
    var divRef = useRef(null);
    var theme = useTheme();
    return (arrayOfColors.length > 0 && (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledRootContainer, { ref: divRef },
            React.createElement(StyledColorScaleContainer, { onClick: appendCustomizedBreakPoints },
                React.createElement(StyledTextureContainer, null,
                    React.createElement(ColorScale, { arrayOfColors: arrayOfColors })),
                React.createElement(StyledCustomScales, null, customScalesName + " Copy")),
            React.createElement("div", { className: "breadCrumbs" },
                React.createElement(IconButton, { size: "small", style: { marginTop: "8px" }, onClick: handleClick },
                    React.createElement(MoreHorizIcon, { fontSize: "small" }))),
            React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                } },
                React.createElement("div", { style: { height: "60px", width: "80px" } },
                    React.createElement(StyledEditContainer, { onClick: openEditModal },
                        React.createElement(EditIcon, { style: { margin: "5px 3px -5px 5px", cursor: "pointer" }, fontSize: "small" }),
                        " ",
                        "Edit"),
                    React.createElement(StyledEditContainer, { onClick: deleteLegend },
                        React.createElement(DeleteOutlinedIcon, { style: { margin: "5px 3px -5px 5px", cursor: "pointer" }, fontSize: "small" }),
                        " ",
                        "Delete"))),
            popUpState === true && (React.createElement(CustomizedDialogs, { openModal: openEditModal, scaleBreakpoints: scaleBreakpoints, scaleData: orderedSelectedColors, customScalesName: customScalesName }))))));
};
//# sourceMappingURL=Legend.js.map